import { makeStyles } from '@material-ui/core';
import { alabaster, porcelain, white } from '../../../abstracts/colours';

const useStyles = makeStyles({
  root: {
    position: 'unset',
    overflow: 'hidden',
  },
  content: {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  summaryRoot: {
    padding: 0,
    '&:hover': {
      backgroundColor: alabaster,
    },
    minHeight: 32,
    width: '100%',
    '&.Mui-expanded': {
      borderBottom: `solid 1px ${porcelain}`,
      minHeight: 32,
    },
  },
  detailsRoot: {
    padding: 0,
  },
  rounded: {
    boxShadow: `0 1px 14px 0 rgba(206, 212, 217, 0.12),
      0 5px 8px 0 rgba(206, 212, 217, 0.14),
      0 3px 5px -1px rgba(206, 212, 217, 0.2)`,
    border: `solid 1px ${porcelain}`,
    backgroundColor: white,
    '&:first-child': {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
    },
    '&:last-child': {
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16,
    },
    '&.Mui-expanded': {
      borderRadius: 16,
    },
  },
});

export default useStyles;
